
/**
 * API 勤怠再計算
 */

export interface ConfirmRecorderByICCard {
  orgCode: string,
  orgName: string,
  loginOrgCode: string,
  loginOrgName: string,
  cardId: string,
  staffName: string,
  inputCardId: string,
  stampTime: string,
  stampMode: number,
  stampByBelongOrg: any
}


export default class ConfirmRecorderByICCardDomain {
  constructor(private rawData: ConfirmRecorderByICCard) {
  // do nothing
  }

  static generateInitial(): ConfirmRecorderByICCardDomain {
    return new ConfirmRecorderByICCardDomain({
      orgCode: '',
      orgName: '',
      loginOrgCode: '',
      loginOrgName: '',
      cardId: '',
      staffName: '',
      inputCardId: '',
      stampTime: '',
      stampMode: 3,
      stampByBelongOrg: 0,
    });
  }

  getRawData(): ConfirmRecorderByICCard {
    return this.rawData;
  }

  get orgCode():string {
    return this.rawData.orgCode;
  }

  set orgCode(orgCode:string) {
    this.rawData.orgCode = orgCode;
  }

  get orgName():string {
    return this.rawData.orgName;
  }

  set orgName(orgName:string) {
    this.rawData.orgName = orgName;
  }

  get loginOrgCode():string {
    return this.rawData.loginOrgCode;
  }

  set loginOrgCode(loginOrgCode:string) {
    this.rawData.loginOrgCode = loginOrgCode;
  }

  get loginOrgName():string {
    return this.rawData.loginOrgName;
  }

  set loginOrgName(loginOrgName:string) {
    this.rawData.loginOrgName = loginOrgName;
  }


  get inputCardId():string {
    return this.rawData.inputCardId;
  }

  set inputCardId(inputCardId:string) {
    this.rawData.inputCardId = inputCardId;
  }

  get cardId():string {
    return this.rawData.cardId;
  }

  set cardId(cardId:string) {
    this.rawData.cardId = cardId;
  }

  get staffName():string {
    return this.rawData.staffName;
  }

  set staffName(staffName:string) {
    this.rawData.staffName = staffName;
  }

  get stampTime():string {
    return this.rawData.stampTime;
  }

  set stampTime(stampTime:string) {
    this.rawData.stampTime = stampTime;
  }

  get stampMode():number {
    return this.rawData.stampMode;
  }

  set stampMode(stampMode:number) {
    this.rawData.stampMode = stampMode;
  }

  get stampByBelongOrg():any {
    return this.rawData.stampByBelongOrg;
  }

  set stampByBelongOrg(stampByBelongOrg:any) {
    this.rawData.stampByBelongOrg = stampByBelongOrg;
  }
  // get

// custom data use DataTable
}
